var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiploma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.32 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcb116;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.19,19.56,16.1,23.43l2.58,1.4V28.7l4.51,2.46,4.51-2.46V24.84l1.29-.7v4.45h1.29V23.43Zm4.4,3.87-4.4,2.4-4.4-2.4,4.4-2.4Zm-1.17,4.5L23.19,29.7,20,27.94v-2.4l3.22,1.76,3.22-1.76Z",
    transform: "translate(-11.68 -6.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.89,6H14.72a3,3,0,0,0-3,3l0,24.32a3,3,0,0,0,3,3H33a3,3,0,0,0,3-3V15.15ZM14.72,33.39V9.07H25.37v7.6H33V33.39Z",
    transform: "translate(-11.68 -6.03)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.f348842cdeca4fbe6ace5c90e14e7cf7.svg";
export { ForwardRef as ReactComponent };